<template>
    <div class="row">
        <div class="col-12 text-center">
            <h2>Registration Successful</h2>
        </div>
        <div class="col-12 text-center h4 py-5">
            Your account has been registered successfully.<br>
            Check your email to activate it.
        </div>

    </div>
</template>

<script>
    export default {
        name: "Success"
    }
</script>

<style scoped>

</style>